import React from 'react';
import { TFunction } from 'i18next';
import { createFormElement } from '../../molecules/Form/FormFactory';
import { optionsProcessor, SelectOption } from '../../molecules/Form/components/FormSelect/FormSelect';
import IParameter from '../../../types/IParameter';
import { AUTOCOMPLETE_VALUES } from './UserRegistrationForm.enums';
import { Namespace } from '../../../translation/namespace';
import { InputType } from '../../molecules/Form';

export function renderFormElement(input: IParameter, onChange: (name: string, values: any) => void, t: TFunction) {
  if (input && input.type) {
    const autoComplete = AUTOCOMPLETE_VALUES[input.name as keyof typeof AUTOCOMPLETE_VALUES] || null;

    if (input.type === InputType.SELECT) {
      input.options = optionsProcessor(input.name, input.options as SelectOption[], Namespace.UserRegistrationForm);
    }

    // quick fix for SIBZIEL-11404 in R7 we need to remove pattern for denying leading whitespaces from Form Model
    if (input.constraints?.pattern === '^[^\\s].*$') {
      input.constraints.pattern = undefined;
    }

    return (
      <React.Fragment key={input.name}>
        {createFormElement({
          autoComplete,
        })(input, 'registration', onChange, t(`labels.${input.name}`))}
      </React.Fragment>
    );
  }

  return null;
}
